import React from "react";
import Header from "./Header";
import TicketSidebar from "./TicketSidebar";

export default function TicketLayout({ children }) {
  return (
    <div className="flex min-h-screen">
      <TicketSidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
}
